/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S7_Body_PostInputs */

const tr_servis_s7_body_post = /** @type {(inputs: Servis_S7_Body_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`'nın 4. bölümünde listelenmiştir. Listeye eklenen yeni bir alt yüklenici halinde, yürürlük tarihinden en az 15 gün önce kayıtlı e-posta adresinizden bilgilendirme yapılır.`)
};

const en_servis_s7_body_post = /** @type {(inputs: Servis_S7_Body_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. If a new sub-processor is added to the list, information is sent to your registered e-mail address at least 15 days before the effective date.`)
};

const de_servis_s7_body_post = /** @type {(inputs: Servis_S7_Body_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` aufgeführt. Wird ein neuer Unterauftragsverarbeiter in die Liste aufgenommen, erfolgt mindestens 15 Tage vor dem Wirksamkeitsdatum eine Information an Ihre registrierte E-Mail-Adresse.`)
};

const ru_servis_s7_body_post = /** @type {(inputs: Servis_S7_Body_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. При добавлении в список нового субподрядчика уведомление направляется на вашу зарегистрированную электронную почту не менее чем за 15 дней до даты вступления в силу.`)
};

/**
* | output |
* | --- |
* | ". If a new sub-processor is added to the list, information is sent to your registered e-mail address at least 15 days before the effective date." |
*
* @param {Servis_S7_Body_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s7_body_post = /** @type {((inputs?: Servis_S7_Body_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S7_Body_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s7_body_post(inputs)
	if (locale === "de") return de_servis_s7_body_post(inputs)
	if (locale === "ru") return ru_servis_s7_body_post(inputs)
	return tr_servis_s7_body_post(inputs)
});